module.exports = __webpack_public_path__ + "img/report.9e122094.png";